export default __webpack_public_path__ + "9a2b628eec44b36564c8b1edb2f1f7ac.svg";